<template>
  <v-container fluid>
      <v-layout justify-center>
          <v-flex md12>
            <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
          </v-flex>
      </v-layout>
      <PlazaDialog
        :model="plaza"
        v-if="get_dialogMain.dialog &&
          (get_dialogMain.type == 'create' || get_dialogMain.type == 'update')" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import PlazaDialog from '@/components/dialogs/nomina/PlazaDialog'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'nomina-config-plazas.store' }
        ],
        titles: [
          { text: 'Zona', value: 'zona.nombre', class: 'black--text' },
          { text: 'Plaza', value: 'nombre', class: 'black--text' },
          { text: 'Tipo Plaza', value: 'tipo_plaza.nombre', class: 'black--text' },
          { text: 'Puesto', value: 'puesto.nombre', class: 'black--text' },
          { text: 'Categoria', value: 'categoria.nombre', class: 'black--text' },
          { text: 'Nivel', value: 'nivel.nivel', class: 'black--text' },
          { text: 'Vacantes', value: 'total', class: 'black--text', align: 'center' },
          { text: 'Ocupados', value: 'ocupados', class: 'black--text', align: 'center' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    plaza: {
      configuraciones: {
        complemento: 'no',
        importe_complemento: 0
      }
    }
  }),
  components: {
    DataTableMain,
    PlazaDialog
  },
  mounted () {
    this.getUrl('POST/nomina/config/plazas/show')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/nomina/config/plazas/show')
    },
    newData (item) {
      this.plaza = { configuraciones: { complemento: 'si', importe_complemento: 0 } }
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nueva Plaza' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    ...mapActions(['getUrlServices', 'postServiceListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects'])
  },
  watch: {
    get_urls () {
      this.getUrl('POST/nomina/config/plazas/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }

}
</script>

<style>

</style>
